import { render } from "./WelcomeAnimation.vue?vue&type=template&id=3dcd9d9c&scoped=true&ts=true"
import script from "./WelcomeAnimation.vue?vue&type=script&lang=ts"
export * from "./WelcomeAnimation.vue?vue&type=script&lang=ts"

import "./WelcomeAnimation.vue?vue&type=style&index=0&id=3dcd9d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcd9d9c"]])

export default __exports__